'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const WizardSidebarTimelineSkippedIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="WizardSidebarTimelineSkippedIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" fill="white" />
        <circle cx="9" cy="9" r="8" fill="white" stroke="#3D517B" strokeWidth="2" />
        <path
          d="M11.4481 8.98801C11.4481 9.21608 11.3504 9.41157 11.1875 9.54191L7.53825 12.7675C7.27758 12.9956 6.88661 12.963 6.69111 12.7024C6.49561 12.4417 6.49561 12.0833 6.75628 11.8552L9.94935 9.05317C9.98191 9.02058 9.98191 8.98801 9.94935 8.92284L6.75628 6.12074C6.49561 5.89267 6.49561 5.50167 6.72368 5.27361C6.95178 5.04554 7.31018 5.01294 7.57085 5.20844L11.22 8.40151C11.3504 8.56444 11.4481 8.75991 11.4481 8.98801Z"
          fill="#3D517B"
        />
      </svg>
    </SvgIcon>
  )
}

WizardSidebarTimelineSkippedIcon.propTypes = {
  sx: PropTypes.object
}
